<template>
  <div v-if="!isLoading">
    <div class="row mx-0">
      <!-- DESKTOP SIDEBAR NAVIGATION START -->
      <div class="col-auto px-0 vh-100 d-none d-md-block">
        <section class="userProfile-leftSide">
          <div
            class="border-bottom menu px-3 py-2"
            :class="editProfile ? 'active' : ''"
            @click="selectedOption('profile')"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"
                fill="#fff"
              />
            </svg>

            Edit your profile
          </div>
          <div
            class="border-bottom menu px-3 py-2 d-flex align-items-center justify-content-between"
            :class="myNotifications ? 'active' : ''"
            @click="selectedOption('notifications')"
          >
            <div>
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84561V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07693 3.43397 3.07693 6.15361V9.84561C3.07693 10.5252 2.52551 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.52941 17.2308 10.7692 15.9909 10.7692 14.4615H9.53847C9.53847 15.3112 8.84967 16 8 16C7.15034 16 6.46154 15.3112 6.46154 14.4615Z"
                  fill="#fff"
                />
              </svg>

              Notifications
            </div>
            <div class="notificationNum" v-if="unread_notification_count > 0">
              {{ unread_notification_count }}
            </div>
          </div>
          <div
            class="border-bottom menu px-3 py-2"
            :class="myTransactions ? 'active' : ''"
            @click="selectedOption('bookings')"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M16.3125 15.75H1.68751C0.756973 15.75 0 14.9931 0 14.0625V11.25C0 10.9391 0.25158 10.6875 0.562503 10.6875C1.49304 10.6875 2.25001 9.93054 2.25001 9C2.25001 8.06947 1.49304 7.31249 0.562503 7.31249C0.25158 7.31253 0 7.06095 0 6.75003V3.93751C0 3.00697 0.756973 2.25 1.68751 2.25H16.3125C17.2431 2.25 18 3.00697 18 3.93751V6.75003C18 7.06095 17.7485 7.31253 17.4375 7.31253C16.507 7.31253 15.75 8.06951 15.75 9.00004C15.75 9.93058 16.507 10.6876 17.4375 10.6876C17.7485 10.6876 18 10.9391 18 11.2501V14.0626C18 14.9931 17.2431 15.75 16.3125 15.75ZM1.12501 11.7559V14.0625C1.12501 14.3729 1.37715 14.625 1.68751 14.625H16.3125C16.6229 14.625 16.875 14.3729 16.875 14.0625V11.7559C15.5929 11.4945 14.625 10.3585 14.625 9C14.625 7.64152 15.5929 6.50557 16.875 6.24407V3.93751C16.875 3.62715 16.6229 3.37501 16.3125 3.37501H1.68751C1.37715 3.37501 1.12501 3.62715 1.12501 3.93751V6.24411C2.4071 6.50557 3.37502 7.64156 3.37502 9.00004C3.37502 10.3585 2.4071 11.4945 1.12501 11.7559Z"
                  fill="#fff"
                />
                <path
                  d="M6.78516 13.2969L10.159 4.30004L11.2123 4.69505L7.83852 13.6919L6.78516 13.2969Z"
                  fill="#fff"
                />
                <path
                  d="M6.33985 9.1875C5.40932 9.1875 4.65234 8.43053 4.65234 7.5C4.65234 6.56947 5.40932 5.8125 6.33985 5.8125C7.27039 5.8125 8.02736 6.56947 8.02736 7.5C8.02736 8.43053 7.27039 9.1875 6.33985 9.1875ZM6.33985 6.9375C6.0295 6.9375 5.77735 7.18965 5.77735 7.5C5.77735 7.81036 6.0295 8.0625 6.33985 8.0625C6.65021 8.0625 6.90236 7.81036 6.90236 7.5C6.90236 7.18965 6.65021 6.9375 6.33985 6.9375Z"
                  fill="#fff"
                />
                <path
                  d="M12.1524 12.6797C11.2218 12.6797 10.4648 11.9227 10.4648 10.9922C10.4648 10.0617 11.2218 9.30469 12.1524 9.30469C13.0829 9.30469 13.8399 10.0617 13.8399 10.9922C13.8399 11.9227 13.0829 12.6797 12.1524 12.6797ZM12.1524 10.4297C11.842 10.4297 11.5899 10.6818 11.5899 10.9922C11.5899 11.3026 11.842 11.5547 12.1524 11.5547C12.4627 11.5547 12.7149 11.3026 12.7149 10.9922C12.7149 10.6818 12.4627 10.4297 12.1524 10.4297Z"
                  fill="#fff"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            My Bookings
          </div>
        </section>
      </div>
      <!-- DESKTOP SIDEBAR NAVIGATION END -->

      <!-- MOBILE SIDEBAR NAVIGATION START -->
      <div class="col-12 d-md-none userProfileMob_drop">
        <div class="section-space-50"></div>
        <b-dropdown
          id="dropdown-1"
          :text="selectedText"
          variant="none"
          class="m-md-2"
        >
          <b-dropdown-item @click="selectedOption('profile')">
            <!-- <img v-lazy="getImageObject()" class="mr-2" alt="Profile" /> -->
            <img
              src="@/assets/img/icons/user.svg"
              class="mr-2"
              alt="Profile"
              height="20px"
              width="20px"
            />
            Edit your profile
          </b-dropdown-item>
          <b-dropdown-item @click="selectedOption('notifications')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <img
                  src="@/assets/img/icons/notificationIcon.svg"
                  class="mr-2"
                  alt="Notifications"
                  height="20px"
                  width="20px"
                />
                Notifications
              </div>
              <div class="notificationNum" v-if="unread_notification_count > 0">
                {{ unread_notification_count }}
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-item @click="selectedOption('bookings')">
            <img
              src="@/assets/img/icons/bookingIcon.svg"
              class="mr-2"
              alt="Bookings"
              height="20px"
              width="20px"
            />My Bookings
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <!-- MOBILE SIDEBAR NAVIGATION END -->

      <div class="col">
        <div class="section-space-50"></div>

        <!-- EDIT YOUR PROFILE START -->
        <section class="container userProfile-rightSide" v-if="editProfile">
          <div class="d-flex align-items-center justify-content-between">
            <div class="section-header-title">Edit your profile</div>
          </div>

          <div class="section-space-50"></div>
          <div class="row">
            <div class="col-12 col-md-3 col-xl-2 text-center align-self-center">
              <div class="uploadProfile">
                <img v-lazy="getImageObject()" alt />
                <label for="myfile" class="py-2">Upload image</label>
                <input
                  type="file"
                  id="myfile"
                  class="d-none"
                  name="myfile"
                  @change="uploadImage"
                />
              </div>
            </div>
            <div
              class="col-12 col-md-9 col-xl-10 text-center text-md-left mt-4 mt-md-0"
            >
              <p class="mb-0 mb-md-1 mt-3 text-capitalize">
                {{ getLoggedUser && getLoggedUser.user_name }}
              </p>
              <p class="mb-0">
                {{ getLoggedUser && getLoggedUser.user_number }}
              </p>
            </div>
          </div>
          <div class="section-space-50"></div>

          <form class="userProfileForm">
            <div class="row">
              <div class="col-md-5 mb-3">
                <p class="mb-1">Full Name</p>
                <input
                  type="text"
                  placeholder="abc"
                  class="form-control"
                  v-model="user_name"
                />
              </div>
              <!-- <div class="col-md-5 mb-3">
                <p class="mb-1">Phone Number</p>
                <input
                  type="text"
                  placeholder="123 123 123"
                  class="form-control"
                  v-model="user_number"
                />
              </div> -->
            </div>

            <div class="row">
              <div class="col-md-5 mb-3">
                <p class="mb-1">Email address</p>
                <input
                  type="text"
                  placeholder="E.g. hello@abc.com"
                  class="form-control"
                  v-model="user_email"
                />
              </div>
              <!-- <div class="col-md-5 mb-3">
                <p class="mb-1">Password</p>
                <span class="passwordField">
                  <input type="text" class="form-control pr-5" />
                  <img src="@/assets/img/icons/eyeIcon.svg" alt />
                </span>
              </div>-->
            </div>
            <div class="section-space-25"></div>
            <div class="text-center">
              <button
                class="btn btn-primary"
                @click.stop.prevent="handleUpdateProfile"
              >
                Update Profile
              </button>
              <span class="d-md-none">
                <button
                  class="btn btn-outline-primary ml-2 px-4"
                  @click.stop.prevent="onLogoutUser"
                >
                  Logout
                </button>
              </span>
              <button
                  class="btn btn-outline-primary ml-2 px-4 mt-2 mt-sm-0"
                  @click.stop.prevent="onDeleteUser"
                >
                  Delete Account
              </button>
            </div>
          </form>
        </section>
        <!-- EDIT YOUR PROFILE END -->

        <!-- NOTIFICATIONS START -->
        <section
          class
          :class="window.width < 340 ? '' : 'container'"
          v-if="myNotifications"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="section-header-title">
              Notifications
              <span
                class="notificationNum ml-2"
                v-if="unread_notification_count > 0"
                >{{ unread_notification_count }}
              </span>
            </div>
            <div
              class="text-rose-gold cursor-pointer"
              @click="markAllAsRead"
              v-if="unread_notification_count > 0"
            >
              Mark all as read
            </div>
          </div>
          <div class="section-space-25"></div>
          <!-- NOTIFICATION CARD START -->
          <div
            class="row notificationCard py-3 mx-0 mb-3"
            v-for="(notificationCard, NotificationInd) in notifications"
            :key="NotificationInd"
            :class="NotificationInd != 0 ? 'disabled' : ''"
          >
            <div class="col-md-10">
              <div class="d-flex">
                <div class="mr-3 notification-img">
                  <img
                    class="img-fluid"
                    v-lazy="
                      notificationCard && notificationCard.notification_image
                        ? IMAGE_URL + notificationCard.notification_image
                        : null
                    "
                    alt
                  />
                </div>
                <div class="d-flex align-items-start flex-column my-md-2">
                  <div class="mb-auto m-fs-14">
                    {{ notificationCard.notification_text }}
                  </div>
                  <div class="text-muted d-none d-md-block m-fs-14">
                    {{ notificationCard.notification_time | dateparse }} |
                    {{ notificationCard.notification_time | timeparse }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 align-self-center mt-3 mt-md-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-md-none m-fs-14">03 March, 2020 | 8:00 pm</div>
                <div>
                  <button
                    class="btn btn-primary"
                    @click="
                      $router.push({
                        name: 'Final Ticket',
                        params: {
                          transaction_id: notificationCard.transaction_id
                        }
                      })
                    "
                  >
                    View Ticket
                  </button>
                </div>
              </div>
            </div>
          </div>
          <EmptyMovieState
            v-if="notifications.length === 0"
            isClass="border-0"
            :emptyMessage="`No Booking History`"
            :isNeedTopSpace="true"
          />
          <!-- NOTIFICATION CARD END -->
        </section>
        <!-- NOTIFICATIONS END -->

        <!-- MY BOOKINGS START -->
        <section
          class
          :class="window.width < 340 ? '' : 'container'"
          v-if="myTransactions"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="section-header-title">My Bookings</div>
            <div
              class="cursor-pointer"
              :class="window.width < 767 ? 'w-50' : ''"
            >
              <div class="has-chevron" :class="filter ? 'chevron-inverse' : ''">
                <input
                  type="search"
                  placeholder="Search movies..."
                  v-model="searchTransaction"
                  v-on:blur="filter = !filter"
                  v-on:focus="filter = !filter"
                  class="form-control"
                  @input="getAllBookings"
                  ref="searchBookings"
                />
              </div>
              <!-- <div class="select-location-box" v-if="filter">
                <ul class="search-result-list">
                  <li>Upcoming</li>
                  <li>All</li>
                </ul>
              </div> -->
            </div>
          </div>
          <div class="section-space-25"></div>

          <!-- TICKET SECTION TO LOOP -->
          <div v-if="user_bookings.length > 0">
            <div
              v-for="(ticket, ticketIndex) in user_bookings"
              :key="ticketIndex"
            >
              <div class="row">
                <div class="col-lg-12 col-xl-10">
                  <!-- TICKET START -->
                  <div
                    class="col-12 FinalTicket px-md-5 px-4 py-4 overflow-hidden"
                    :class="ticketIndex == 0 ? 'active' : ''"
                  >
                    <div class="row">
                      <div class="col-4 col-md-2 booking-ticket-img">
                        <img
                          v-lazy="
                            ticket && ticket.image_path_1
                              ? IMAGE_URL + ticket.image_path_1
                              : null
                          "
                          alt="Movie Banner"
                          class="img-fluid rounded bt-img"
                        />
                      </div>
                      <div class="col-8 col-md-8 pl-1 pl-sm-2 pl-md-3">
                        <div>
                          <p class="titleText font-weight-600 mb-1">
                            {{ ticket && ticket.Film_strTitle }}
                          </p>
                          <ul class="list-inline titleText d-none d-md-block">
                            <li class="list-inline-item">
                              {{
                                ticket && ticket.Session_dtmRealShow | dateparse
                              }}
                              |
                              {{
                                ticket && ticket.Session_dtmRealShow | timeparse
                              }}
                            </li>
                          </ul>
                          <div class="">
                            <p class="mb-0">
                              {{ ticket && ticket.Cinema_strName }}
                            </p>
                            <p class="mb-0">
                              {{ ticket && ticket.Screen_strName }}
                            </p>
                            <p class="mb-0">
                              {{ ticket && ticket.cinema_address }}
                            </p>
                          </div>
                        </div>

                        <div class="d-none d-md-block">
                          <!-- SHOW THIS IF USER SELECTED F&B -->
                          <div
                            class="mt-1 mt-md-3"
                            v-if="ticket && ticket.items"
                          >
                            <div class="">
                              <div class="d-flex">
                                <div class="mr-2 mt-1">
                                  <img
                                    src="@/assets/img/icons/popcorn-icon.svg"
                                    alt="Popcorn Icon"
                                  />
                                </div>
                                <div class>
                                  <p class="mb-0">Food &amp; Beverage</p>
                                  <ul class="list-inline  fnbList">
                                    <li
                                      v-for="(ticketItem,
                                      ticketItemIndex) in ticket.items"
                                      :key="ticketItemIndex"
                                      class="list-inline-item"
                                    >
                                      {{ ticketItem.quantity }}
                                      {{ ticketItem.Item_strDescription }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- SHOW THIS IF USER SELECTED F&B -->
                        </div>
                      </div>
                      <div class="col-md-2 d-md-block d-none text-right">
                        <p class="text-center mb-0">
                          {{
                            ticket && ticket.number_of_seats === 1
                              ? "No of Ticket"
                              : "No of Tickets"
                          }}
                        </p>
                        <p
                          class="text-center text-rose-gold font-weight-bold fs-24 mb-1"
                        >
                          {{ ticket && ticket.number_of_seats }}
                        </p>

                        <div>
                          <img
                            :src="
                              'http://api.qrserver.com/v1/create-qr-code/?data=' +
                                ticket.intBookId +
                                '+&size=100x100'
                            "
                            alt
                            class="img-fluid"
                          />
                          <span class="text-left mr-3">
                            {{ ticket && ticket.strBookId }}</span
                          >
                        </div>
                      </div>

                      <div class="col-5 mt-3 mx-auto text-center d-md-none">
                        <img
                          :src="
                            'http://api.qrserver.com/v1/create-qr-code/?data=' +
                              ticket.intBookId +
                              '+&size=100x100'
                          "
                          alt
                          class="img-fluid"
                        />
                        <div class="text-center mt-1 small">
                          {{ ticket && ticket.strBookId }}
                        </div>
                      </div>
                    </div>

                    <!-- DATE SECTION FOR MOBILE SITE -->
                    <div class="row d-md-none my-4">
                      <div class="col-8">
                        <p class=" mb-1">Date</p>
                        <p class="mb-0 titleText font-weight-bold">
                          {{ ticket && ticket.Session_dtmRealShow | dateparse }}
                        </p>
                      </div>
                      <div class="col-4 text-right">
                        <p class=" mb-1">Time</p>
                        <p class="mb-0 titleText font-weight-bold">
                          {{ ticket && ticket.Session_dtmRealShow | timeparse }}
                        </p>
                      </div>
                    </div>
                    <!-- DATE SECTION FOR MOBILE SITE -->

                    <!-- SHOW THIS IF USER SELECTED F&B -->
                    <div
                      class="row mt-1 mt-md-3 d-md-none"
                      v-if="ticket && ticket.items"
                    >
                      <div class="col-12 col-md-10 offset-md-2">
                        <div class="d-flex">
                          <div class="mr-2 mt-1">
                            <img
                              src="@/assets/img/icons/popcorn-icon.svg"
                              alt="Popcorn Icon"
                            />
                          </div>
                          <div class>
                            <p class="mb-0">Food &amp; Beverage</p>
                            <ul class="list-inline fnbList">
                              <li
                                v-for="(ticketItem,
                                ticketItemIndex) in ticket.items"
                                :key="ticketItemIndex"
                                class="list-inline-item"
                              >
                                {{ ticketItem.quantity }}
                                {{ ticketItem.Item_strDescription }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- SHOW THIS IF USER SELECTED F&B -->

                    <div class="row dividerLine my-2"></div>

                    <div class="row">
                      <div class="col-8">
                        <p class="mb-1">SEAT NO.</p>
                        <ul
                          class="list-inline mb-0 seatList titleText font-weight-bold"
                        >
                          <!-- v-for="(seat, seatIndex) in 5" -->
                          <!--  :key="seatIndex" -->
                          <li class="list-inline-item mob-fs-14">
                            {{ ticket && ticket.strSeatInfo }}
                          </li>
                        </ul>
                      </div>
                      <div class="col-4 d-none d-md-block text-right">
                        <p
                          class="mb-1"
                          v-if="ticket && ticket.payment_status === 'Confirmed'"
                        >
                          AMOUNT PAID
                        </p>
                        <p class="smallLightText mb-1" v-else>AMOUNT PENDING</p>
                        <p class="mb-0 titleText font-weight-bold">
                          ₹{{ ticket && (ticket.curTotal + (ticket.convenience_fee || 0) - (ticket.DiscountAmount || 0)).toFixed(2) }}
                        </p>
                      </div>

                      <!-- VISIBLE ON MOBILE SITE -->
                      <div class="col-4 text-center lh-2 d-md-none">
                        <p class="tickesNum mb-0 fs-20">
                          {{ ticket && ticket.number_of_seats }}
                        </p>
                        <p class="titleText fs-14">
                          {{
                            ticket.number_of_seats === 1 ? "Ticket" : "Tickets"
                          }}
                        </p>
                      </div>
                      <!-- VISIBLE ON MOBILE SITE -->
                    </div>

                    <div
                      class="row align-items-center mt-2 mx-0 booking-details"
                    >
                      <div
                        class="col-6 col-md-4 text-center text-md-left px-0 px-1"
                      >
                        <p class="mb-0">Booking ID:</p>
                        <p class="mb-0 font-weight-600">
                          {{ ticket && ticket.intBookId }}
                        </p>
                      </div>
                      <div class="col-6 col-md-4 px-0 px-1">
                        <p class="mb-0">Booking Date:</p>
                        <p class="mb-0 font-weight-600">
                          {{ ticket && ticket.transaction_time | dateparse }}
                          |
                          {{ ticket && ticket.transaction_time | timeparse }}
                        </p>
                      </div>
                      <!-- <div class="col-6 col-md-4 px-0 px-1 text-right">
                      <p class="text-muted mb-0">Payment Method:</p>
                      <p class="mb-0 font-weight-600">UPI : axxxx@okaxis</p>
                    </div> -->
                    </div>
                  </div>
                  <!-- TICKET END -->
                </div>
                <!-- <div class="col-lg-12 col-xl-2 text-center align-self-center">
                  <button class="btn btn-primary mb-xl-3 bn_w-100">
                    Resend m-Ticket
                  </button>
                  <button class="btn btn-outline-primary bn_w-100">
                    Send as gift
                  </button>
                </div> -->
              </div>
              <div class="section-space-50"></div>
            </div>
          </div>
          <!-- <empty-state
            v-else
            isClass="border-0"
            :emptyMessage="`No transactions to show`"
            :isNeedTopSpace="true"
          /> -->
          <div class="section-space-25"></div>
          <EmptyMovieState
            v-if="user_bookings.length === 0"
            isClass="border-0"
            :emptyMessage="`No Booking History`"
            :isNeedTopSpace="true"
          />
        </section>
        <!-- MY BOOKINGS END -->

        <div class="section-space-50"></div>
      </div>

      <!-- USER PROFILE - UPDATE SUCCESSFUL POPUP -->
      <b-modal id="profileUpdated" title="Profile updated" hide-footer>
        <div>
          <div class="p-3">
            <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
              <div class="row my-4">
                <div class="col-12 text-center">
                  <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
                </div>
                <div class="col-12 text-center my-4">
                  <p>Your profile was successfully updated!</p>
                </div>
                <div class="col-12">
                  <button
                    class="btn btn-primary w-100"
                    @click="$bvModal.hide('profileUpdated')"
                  >
                    DONE
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="rainbow-line">
            <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ProfileService from "@/apiServices/ProfileService";
import MasterService from "@/apiServices/MasterService";
import { mapState, mapGetters, mapActions } from "vuex";
import router from "@/router";
import { IMAGEURL } from "@/config";
import Vue from "vue";
export default {
  data() {
    return {
      searchTransaction: null,
      unread_notification_count: null,
      IMAGE_URL: IMAGEURL,
      editProfile: true,
      myTransactions: false,
      myNotifications: false,
      notifications: [],
      selectedText: "Select Option",
      filter: false,
      filterMenu: "",
      ticketActive: false,
      user_name: null,
      user_email: null,
      user_number: null,
      user_bookings: [],
      isLoading: null,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"])
  },
  watch: {
    "$route.params": {
      handler(newValue, oldValue) {
        console.log("newValue,oldValue", newValue, oldValue);
        this.changeComponent(newValue.component_name);
      }
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    if (!this.getIsUserLogged) {
      console.log("pushed back");
      console.log("this.getIsUserLogged", this.getIsUserLogged);
      this.$router.push({ path: "/" });
    } else {
      const { component_name } = this.$route.params;
      console.log("component_name", component_name);
      if (component_name) {
        this.changeComponent(component_name);
      }
      this.user_name = this.getLoggedUser.user_name;
      this.user_email = this.getLoggedUser.user_email;
      this.user_number = this.getLoggedUser.user_number;
      this.getAllBookings();
    }
  },
  methods: {
    getImageObject() {
      return {
        src:
          this.getLoggedUser && this.getLoggedUser.profile_image
            ? this.IMAGE_URL + this.getLoggedUser.profile_image
            : null,
        error: ".../../../../../static/img/dummy.svg",
        loading: ".../../../../../static/img/dummy.svg"
      };
    },
    async uploadImage(event) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      const { data } = await MasterService.UploadImage(formData);
      if (data && data.status) {
        console.log("data.data[", data.data["imagePath"]);
        const response = await ProfileService.UpdateProfileImage({
          profile_image: data.data["imagePath"]
        });
        if (response.data && response.data.status) {
          console.log("update success");
          this.setUserProfileImage({ image: data.data["imagePath"] });
        }
      }
    },
    changeComponent(component_name) {
      if (component_name) {
        switch (component_name) {
          case "editProfile":
            this.selectedText = "Edit your profile";
            this.editProfile = true;
            this.myTransactions = false;
            this.myNotifications = false;
            break;
          case "myTransactions":
            this.selectedText = "My Bookings";
            this.myTransactions = true;
            this.editProfile = false;
            this.myNotifications = false;
            break;
          case "notifications":
            this.selectedText = "Notifications";
            this.myNotifications = true;
            this.myTransactions = false;
            this.editProfile = false;
            break;
          default:
            this.selectedText = "Edit your profile";
            this.editProfile = true;
            this.myTransactions = false;
            this.myNotifications = false;
        }
      }
    },
    ...mapActions([
      "setUserLoggedUser",
      "setUnreadNotificationCount",
      "setUserProfileImage",
      "onLogoutUser",
      "onDeleteUser"
    ]),
    // async getProfileDetails() {
    //   const response = await ProfileService.GetProfileDetails();
    //   const { data } = response;
    //   if(data && data.status){

    //   }
    // },
    async getAllBookings() {
      this.isLoading = true;
      let loader = Vue.$loading.show();
      try {
        let search = this.searchTransaction || null;
        const response = await ProfileService.GetAllBookings({ search });
        const { data } = response;
        if (data && data.status) {
          this.user_bookings = data.data.bookings;
          this.notifications = data.data.notifications;
          this.unread_notification_count =
            data.data.total_unread_notifications_count;
        }
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
        this.isLoading = false;
        this.$nextTick(() => {
          this.$refs.searchBookings.focus();
        });
      }
    },
    async markAllAsRead() {
      try {
        const response = await ProfileService.MarkUnreadNotificationsRead();
        const { data } = response;
        if (data && data.status) {
          this.unread_notification_count = 0;
          // this.$store.dispatch("setUnreadNotificationCount", 0);
          this.setUnreadNotificationCount({ count: 0 });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleUpdateProfile() {
      const response = await ProfileService.EditProfileDetails({
        user_name: this.user_name,
        user_email: this.user_email,
        user_number: this.user_number
      });
      const { data } = response;
      if (data && data.status) {
        await this.setUserLoggedUser(data.data);
        this.$bvModal.show("profileUpdated");
      }
    },
    selectedOption: function(isSelected) {
      this.selectedText = "Select Option";
      if (isSelected === "profile") {
        this.selectedText = "Edit your profile";
        this.editProfile = true;
        this.myNotifications = false;
        this.myTransactions = false;
      } else if (isSelected === "notifications") {
        this.selectedText = "Notifications";
        this.myNotifications = true;
        this.editProfile = false;
        this.myTransactions = false;
      } else if (isSelected === "bookings") {
        this.selectedText = "My Bookings";
        this.myTransactions = true;
        this.editProfile = false;
        this.myNotifications = false;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
  // tickethover: function() {
  //   this.ticketActive = !this.ticketActive;
  // }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/userProfile.vue